export const isCanvasVisible = (routerName) => {
    return routerName === 'home' || routerName === 'farms presentation' || routerName === 'airport presentation' || routerName === 'area presentation' || routerName === 'products';
}


// WEBPACK FOOTER //
// ./src/helpers/helpers.js